var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1326",
    "data-name": "Group 1326",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.717,
    height: 16.717,
    viewBox: "0 0 16.717 16.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 8.359,
    cy: 8.359,
    r: 8.359,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M15.557,11.374a.434.434,0,0,0,0,.611l2.02,2.023H11.3a.432.432,0,0,0,0,.864H17.57L15.551,16.9a.437.437,0,0,0,0,.611.43.43,0,0,0,.608,0L18.9,14.746h0a.485.485,0,0,0,.09-.136.412.412,0,0,0,.033-.166.433.433,0,0,0-.123-.3l-2.738-2.757A.423.423,0,0,0,15.557,11.374Z",
    transform: "translate(-6.907 -5.915)",
    fill: "#b3070f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c4d52eec51b95097ed047c1944f87f19.svg";
export { ForwardRef as ReactComponent };